module.exports = __webpack_public_path__ + "img/sf.286281ce.png";